import { logger } from '@/infrastructure/logger';
import { ToggleType } from '@/presentation/components/toggle/index';
import { getToggleConfig, ToggleConfig } from './service';

export class Toggle {
  private static instance: Toggle;

  private static cached = new Map<string, ToggleConfig>();

  constructor() {
    if (!Toggle.instance) {
      Toggle.instance = this;
    }
    return Toggle.instance;
  }

  public async isEnable(configName: string, type: ToggleType[], options: {
    user?: string;
    appId?: string;
    // 备用
    customValidator?: (config: ToggleConfig) => void;
  }): Promise<boolean> {
    const toggleConfig = await this.getConfig(configName);

    if (!toggleConfig) {
      logger.error(`can not find config ${configName}`);
      return false;
    }

    let toggleEnabled = false;
    const { enable, userList = [], appIds = [], fullRelease = false } = toggleConfig;

    if (!enable) return false;

    if (fullRelease) return true;

    type.forEach((toggleType) => {
      if (toggleType === 'user') {
        toggleEnabled = toggleEnabled || userList.includes(options.user as string);
      } else if (toggleType === 'appId') {
        toggleEnabled = toggleEnabled || appIds.includes(options.appId as string);
      }
    });

    return toggleEnabled;
  }

  public async isEnableByUser(configName: string, user: string): Promise<boolean> {
    const toggleConfig = await this.getConfig(configName);

    if (!toggleConfig) {
      throw new Error(`can not find config ${configName}`);
    }

    const { enable, userList } = toggleConfig;
    return enable && userList.includes(user);
  }

  private async getConfig(configName: string): Promise<ToggleConfig | null> {
    let toggleConfig = null;
    if (Toggle.cached.has(configName)) {
      toggleConfig = Toggle.cached.get(configName);
    } else {
      toggleConfig = await getToggleConfig(configName);
      if (toggleConfig) {
        Toggle.cached.set(configName, toggleConfig);
        console.log('toggleConfig', configName,  toggleConfig);
      }
    }
    return toggleConfig as ToggleConfig;
  }
}
